import { Box, Button, Success } from "@bcc-ui/ui-components";
import * as React from "react";
import { useTranslation } from "react-i18next";

import style from "./audit-log-dialog.scss";
import CopyToClipboard from "components/copy-to-clipboard/CopyToClipboard";
import { parseDownloadData } from "services/audit-log/AuditLogService";
import { formatTimestamp } from "utils/format";
import { useTheme } from "utils/useTheme";

import testIds from "testIds.json";

interface Props {
    notificationData: string;
}

function AuditLogDownloadDialog(props: Props) {
    const { t } = useTranslation();
    const theme = useTheme();

    const [data] = React.useState(() => parseDownloadData(props.notificationData));

    if (!data) {
        return <div>{t("AuditLogs.export.parseError")}</div>;
    }

    const isLinkValid = new Date(data.expiration) >= new Date();

    return (
        <Box columnLayout gap="Xs" className={style.centeredBody}>
            <Success size={40} color={theme.successIconColor} detailColor={theme.contentBackgroundColor} />
            <div>{t("AuditLogs.export.exportSuccessZip", { count: data.totalLogs })}</div>
            <Box marginTop="Md">
                <Button
                    variant="Primary"
                    onClick={() => {
                        window.location.href = data.downloadUrl;
                    }}
                    disabled={!isLinkValid}
                    testId={testIds.common.exportFileDialog.downloadButton}
                >
                    {t("AuditLogs.export.downloadLogs")}
                </Button>
            </Box>
            <div>
                <span>{t("Common.downloadLink")}</span>
                <CopyToClipboard value={data.downloadUrl} />
            </div>
            <div>
                {isLinkValid
                    ? t("Notification.reportNotifications.linkExpiration", {
                          date: formatTimestamp(data.expiration),
                      })
                    : t("Notification.reportNotifications.linkNotAvailable")}
            </div>
        </Box>
    );
}

export default AuditLogDownloadDialog;
